import * as React from "react";
import {History} from "history";
import {Redirect, RouteComponentProps, withRouter} from "react-router";
import {resolvePathWithSpaceId} from "../resolvePathWithSpaceId";
import LocationDescriptor = History.LocationDescriptor;

interface InternalRedirectComponentProps {
    to: LocationDescriptor;
    push?: boolean;
    exact?: boolean;
    from?: string;
}

type InternalRedirectProps = InternalRedirectComponentProps & RouteComponentProps<any>;

const InternalRedirect: React.SFC<InternalRedirectProps> = (props: InternalRedirectProps) => {
    /* tslint:disable:jsx-ban-elements */
    return <Redirect from={props.from} to={resolvePathWithSpaceId(props.to, props.match.params.spaceId)} push={props.push} exact={props.exact} />;
};

export default withRouter(InternalRedirect);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Navigation/InternalRedirect/InternalRedirect.tsx